import type { SVGProps } from "react";
import * as React from "react";

export const PlusIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 42 43"
    className="fill-current"
    {...props}
  >
    <path
      fill="currentColor"
      d="M16.806 38.111v-12H4.947c-2.464 0-4.447-2.006-4.447-4.5 0-2.493 1.983-4.5 4.447-4.5h11.859v-12c0-2.493 1.982-4.5 4.447-4.5s4.447 2.007 4.447 4.5v12h11.859c2.464 0 4.447 2.007 4.447 4.5 0 2.494-1.983 4.5-4.447 4.5H25.7v12c0 2.494-1.983 4.5-4.447 4.5s-4.447-2.006-4.447-4.5"
    />
  </svg>
);
